
export const menuGroups = [
  {
    id: 'main',
    title: 'ໜ້າຫຼັກ',
    icon: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z',
    items: [
      { id: 'dashboard', title: 'Dashboard', to: '/home/dashboard' }
    ]
  },
  {
    id: 'students',
    title: 'ນັກຮຽນ',
    icon: 'M12 3L1 9l11 6 9-4.91V17h2V9L12 3z',
    items: [
      { id: 'student-new', title: 'ນັກຮຽນໃໝ່', to: '/home/students/new' },
      { id: 'student-list', title: 'ລາຍຊື່ນັກຮຽນ', to: '/home/students/list' },
      { id: 'student-attendance', title: 'ຕິດຕາມການມາຮຽນ', to: '/home/students/attendance' },
      { id: 'student-scores', title: 'ຄະແນນປະຈຳເດືອນ', to: '/home/students/monthly-scores' },
      { id: 'student-exams', title: 'ຜົນການສອບເສັງ', to: '/home/students/exam-results' },
      { id: 'student-import', title: 'ນຳເຂົ້າຂໍ້ມູນນັກຮຽນ (Excel)', to: '/home/students/import' }
    ]
  },
  {
    id: 'oversea',
    title: 'ນັກສຶກສາຕ່າງປະເທດ',
    icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.9 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z',
    items: [
      { id: 'student-oversea-list', title: 'ລາຍຊື່ນັກສຶກສາຮຽນຕ່າງປະເທດ', to: '/home/students/oversea/list' },
      { id: 'student-oversea-new', title: 'ລົງທະບຽນນັກສຶກສາໃໝ່', to: '/home/students/oversea/new' },
      { id: 'student-oversea-active', title: 'ນັກສຶກສາຕ່າງປະເທດ ທີ່ກຳລັງສຶກສາຢູ່', to: '/home/reports/oversea-active' },
      { id: 'student-oversea-graduate', title: 'ນັກສຶກສາຕ່າງປະເທດ ທີ່ຮຽນຈົບແລ້ວ', to: '/home/reports/oversea-graduate' }
    ]
  },
  {
    id: 'transfer',
    title: 'ການຍົກຍ້າຍໂຮງຮຽນ',
    icon: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
    items: [
      { id: 'student-transfer-list', title: 'ຄຳຮ້ອງຍົກຍ້າຍໂຮງຮຽນ', to: '/home/students/transfer/list' },
      { id: 'student-transfer-new', title: 'ສ້າງຄຳຮ້ອງຍົກຍ້າຍ', to: '/home/students/transfer/new' }
    ]
  },
  {
    id: 'academic',
    title: 'ວິຊາການ',
    icon: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 5.4 1 6.5V19c1.45-1.1 3.55-1.5 5.5-1.5s4.05.4 5.5 1.5c1.45-1.1 3.55-1.5 5.5-1.5s4.05.4 5.5 1.5V6.5c-.6-.45-1.26-.75-2-1zM11 16.5c-1.45-1.1-3.55-1.5-5.5-1.5s-4.05.4-5.5 1.5V7c1.45-1.1 3.55-1.5 5.5-1.5S9.55 5.9 11 7v9.5z',
    items: [
      { id: 'academic-promotion', title: 'ເລືອນຊັ້ນ', to: '/home/academic/promotion' },
      { id: 'academic-promotion-history', title: 'ປະຫວັດການເລືອນຊັ້ນ', to: '/home/academic/promotion-history' },
      { id: 'academic-year', title: 'ຈັດການສົກຮຽນ', to: '/home/academic/year/list' },
      { id: 'academic-curriculum', title: 'ລາຍຊື່ວິຊາຮຽນ', to: '/home/academic/curriculum' }
    ]
  },
  {
    id: 'staff',
    title: 'ຄູສອນ ແລະ ພະນັກງານ',
    icon: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
    items: [
      { id: 'staff-list', title: 'ລາຍຊື່ຄູ ແລະ ພະນັກງານ', to: '/home/staff/list' },
      { id: 'staff-new', title: 'ເພີ່ມພະນັກງານໃໝ່', to: '/home/staff/new' }
    ]
  },
  {
    id: 'reports',
    title: 'ລາຍງານ',
    icon: 'M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z',
    items: [
      { id: 'report-school', title: 'ລາຍງານຂັ້ນໂຮງຮຽນ', to: '/home/reports/school' },
      { id: 'report-district', title: 'ສະຖິຕິນັກຮຽນທົ່ວເມືອງ', to: '/home/reports/district-stats' },
      { id: 'report-province', title: 'ສະຖິຕິນັກຮຽນທົ່ວແຂວງ', to: '/home/reports/province-stats' },
      { id: 'report-national', title: 'ສະຖິຕິນັກຮຽນທົ່ວປະເທດ', to: '/home/reports/national-stats' },
     
    ]
  },
  {
    id: 'school',
    title: 'ຂໍ້ມູນໂຮງຮຽນ',
    icon: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z',
    items: [
      { id: 'school-overview', title: 'ພາບລວມຂໍ້ມູນໂຮງຮຽນ', to: '/home/school/overview' },
      { id: 'school-info', title: 'ຂໍ້ມູນໂຮງຮຽນ', to: '/home/school/info' },
      { id: 'school-infrastructure', title: 'ຂໍ້ມູນພື້ນຖານໂຄງລ່າງ', to: '/home/school/infrastructure' },
      { id: 'school-facilities', title: 'ສິ່ງອຳນວຍຄວາມສະດວກ', to: '/home/school/facilities' },
      { id: 'school-materials', title: 'ປື້ມແບບຮຽນ ແລະ ອຸປະກອນ ການຮຽນການສອນ', to: '/home/school/materials' },
      { id: 'school-was-garden' , title: 'ນ້ຳ-ສວນ-ອາຫານທ່ຽງ', to: '/home/school/was-garden' },
      { id: 'school-education-plan', title: 'ແຜນພັດທະນາການສຶກສາຂັ້ນບ້ານ', to: '/home/school/education-plan' }
    ]
  },
  {
    id: 'system',
    title: 'ຈັດການລະບົບ',
    icon: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z',
    requiredLevel: 1, // ສະເພາະ Admin ເທົ່ານັ້ນ
    items: [
      { id: 'system-permissions', title: 'ກຳນົດສິດການໃຊ້ງານ', to: '/home/system/permissions', requiredLevel: 1 },
      { id: 'system-users', title: 'ລາຍຊື່ຜູ້ໃຊ້ທັງໝົດ', to: '/home/system/users' },
      { id: 'system-user-new', title: 'ເພີ່ມຜູ້ໃຊ້ໃໝ່', to: '/home/system/users/new' },
      { id: 'system-change-school', title: 'ປ່ຽນໂຮງຮຽນ', to: '/home/system/change-school' },
      { id: 'system-change-password', title: 'ປ່ຽນລະຫັດຜ່ານ', to: '/home/system/users/change-password' },
      { id: 'system-schools', title: 'ຈັດການໂຮງຮຽນ', to: '/home/system/schools', requiredLevel: 1 }
    ]
  }
];
